<template>
    <div>
        <v-app-bar
            app
            dark
            elevation="1"
            height="60"
            hide-on-scroll
            class="px-0"
        >
            <img src="@/assets/logo_white_packhai_fulfillment.png" style="width: 156px">
        </v-app-bar>
    </div>
</template>

<script>
    export default {
        methods: {
            bt_logout_click() {
                localStorage.removeItem("shop_id")
                localStorage.removeItem("staff_id")
                this.$router.push("/login")
            },

            reload(path) {
                if (path != this.$route.path) {
                    this.$router.push(path)
                } else {
                    window.location.reload()
                }
            }
        },
    }
</script>
